import { ReactiveFormsModule } from '@angular/forms';
import {} from '@angular/common/http';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducers, rootReducer } from './store';
import { SharedDataEffects } from '../app/store/effects/shared-data.effect';
import { MaterialModule } from './shared/material.module';

import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { OmnitureTags } from './shared/omnitureTags';

export const APP_IMPORTS = [
  StoreRouterConnectingModule,
  EffectsModule.forRoot([SharedDataEffects]),
  StoreModule.forRoot(reducers, { initialState: {}, runtimeChecks: { strictStateImmutability: true } }),
  MaterialModule,
  ReactiveFormsModule,
  AppRoutingModule,
  SharedModule.forRoot()
];
